import { LayersControl, Marker, Popup } from "react-leaflet";
import { useMapStore } from "../../store/mapStore";
import userDroneMarkerPng from "../../assets/droneMarker.png";
import { useList } from "react-firebase-hooks/database";
import { ref } from "firebase/database";
import { db } from "../../firebase";
import { useEffect, useState } from "react";
import { Icon } from "leaflet";
import { useNavigate } from "react-router-dom";
import Legend from "../../components/legends/legends";

const { Overlay } = LayersControl;

const DronesMapViewLayer = () => {
    const [dronesData] = useList(ref(db, "drones/"));
    const { userDronesIdsStore } = useMapStore((state) => state)
    const [fireDrones, setDrones] = useState([]);
    const navigate = useNavigate()
    useEffect(() => {
        setDrones(dronesData.map((snap) => ({ droneId: snap.key, info: snap.val() })));
    }, [dronesData]);

    const legendData = [
        {
            title: "User Drone",
            img: userDroneMarkerPng,
        },
    ];

    return (
        <>
            <Overlay checked name="Overlay Layer">
                {userDronesIdsStore && fireDrones?.length !== 0 && fireDrones?.map((drone, index) => (
                    <>
                        {userDronesIdsStore?.includes(drone.droneId) && <Marker
                            key={index}
                            position={[
                                drone.info.utm.currentPosition.lat,
                                drone.info.utm.currentPosition.lng,
                            ]}
                            icon={
                                new Icon({
                                    iconUrl: userDroneMarkerPng,
                                    iconSize: [50, 50],
                                    iconAnchor: [25, 25],
                                })
                            }
                            eventHandlers={{
                                mouseover: (event) => event.target.openPopup(),
                                mouseout: (event) => event.target.closePopup(),
                                click: () => {
                                    navigate(`/dashboard/drone-details/${drone.droneId}`)
                                },
                            }}
                        >
                            <Popup>
                                <span className="font-extrabold">{drone.info.utm.droneName}</span>
                                <br />
                                <span>{drone.info.utm.currentPosition.lat},{drone.info.utm.currentPosition.lng}</span>
                            </Popup>
                        </Marker>}
                    </>
                ))}
                <Legend data={legendData} />
            </Overlay>
        </>
    )
}

export default DronesMapViewLayer;